import '@faceup/moment'
import { Device } from '@capacitor/device'
import { locales } from '@faceup/ui-base'
import { convertBasenameToLanguage } from '@faceup/utils'

export const translations = {
  ant: locales,
}

export const getDeviceInfo = async () => {
  const { platform } = await Device.getInfo()
  const { value: language } = await Device.getLanguageCode()

  return {
    platform,
    language: convertBasenameToLanguage(language),
  }
}
